import { PhoneCountryType } from "@shared/lib/libphonenumber/api";
import { useEffect, useState } from "react";

export default function usePhoneNumberInput(
  handleSetPhone: (input: string, country: PhoneCountryType) => void,
  countryInput?: PhoneCountryType
) {
  const [selectedCountry, setSelectedCountry] = useState<PhoneCountryType>({
    countryCode: countryInput?.countryCode ?? "ca",
  });

  // Sync internal state when countryInput prop changes
  useEffect(() => {
    if (
      countryInput?.countryCode &&
      countryInput.countryCode !== selectedCountry.countryCode
    ) {
      setSelectedCountry(countryInput);
    }
  }, [countryInput?.countryCode]);

  const handleChange = (value: string, country: PhoneCountryType) => {
    // Only treat as a country change (user selected from dropdown) if:
    // 1. The country code has changed
    // 2. AND the value is empty (dropdown selection clears the input field)
    const isDropdownCountryChange =
      selectedCountry.countryCode !== country.countryCode && !value;

    if (isDropdownCountryChange) {
      handleSetPhone("", country);
      setSelectedCountry(country);
      return;
    }

    // Use our selected country (or countryInput), not the library's guess
    const countryToUse = countryInput ?? selectedCountry;

    // Prepend dial code if needed
    if (countryToUse.dialCode && !value.startsWith(countryToUse.dialCode)) {
      handleSetPhone(countryToUse.dialCode + value, countryToUse);
    } else {
      handleSetPhone(value, countryToUse);
    }
  };

  return { selectedCountry, handleChange };
}
